export const MESSAGE = "admin/message";
